import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { CartService } from 'src/app/shared/services/cart.service';
import { RazorpayService } from 'src/app/service/razorpay.service';
import { OrderService } from 'src/app/service/order.service';
import { environment } from 'src/environments/environment';
import { TokenStorageService } from 'src/app/service/token-storage.service';
declare let Razorpay: any;

@Component({
  selector: 'app-checkout',
  templateUrl: './checkout.component.html',
  styleUrls: ['./checkout.component.scss']
})
export class CheckoutComponent implements OnInit{

  public isOpenLogin = false;
  public isOpenCoupon = false;
  public couponCode: string = '';
  public payment_name: string = '';

  public checkoutForm!: FormGroup;
  public formSubmitted = false;

  constructor(
    public cartService: CartService,
    public toastrService: ToastrService,
    private razorpayService: RazorpayService,
    private changeDetectorRef: ChangeDetectorRef,
    private orderApi:OrderService,
    public tokenStorage:TokenStorageService,
  ) {
    this.checkoutForm = new FormGroup({
      first_name:new FormControl(null,Validators.required),
      last_name:new FormControl(null,Validators.required),
      company:new FormControl(null),
      address_line1:new FormControl(null,Validators.required),
      address_line2:new FormControl(null),
      country:new FormControl('india',Validators.required),
      city:new FormControl(null,Validators.required),
      state:new FormControl(null,Validators.required),
      postcode:new FormControl(null,Validators.required),
      phone:new FormControl(null,Validators.required),
      notes:new FormControl(null),
      email:new FormControl(null,[Validators.required,Validators.email]),
      //password:new FormControl(null,[Validators.required]),
      order_total:new FormControl(this.cartService.totalPriceQuantity().total,[Validators.required]),
    })

   }

  authData:any = null;
  ngOnInit () {

    if(this.tokenStorage.isLogin()){
      let authData = this.tokenStorage.getUser();
      if(authData){
        this.checkoutForm.patchValue({
          first_name:authData.first_name,
          last_name:authData.last_name,
          company:authData.company,
          address_line1:authData.address_line1,
          address_line2:authData.address_line2,
          city:authData.city,
          state:authData.state,
          postcode:authData.postcode,
          phone:authData.phone,
          email:authData.email,
        });
      }
    }
    this.razorpayService.lazyLoadLibrary('https://checkout.razorpay.com/v1/checkout.js').subscribe();
  }

  RAZORPAY_OPTIONS:any = {
    description: 'Load Wallet',
    currency: 'INR',
    amount: '',
    name: 'IT Wala Technologies',
    key: 'rzp_test_Jwt0nZRnLlCnNd',
    order_id: '',
    reference_id: '',
    image:'/assets/img/dummy/It-wala.png',
    //callback_url: environment.apiURL+'callback_url',
    //callback_url: 'http://www.itwala/api/callback_url',
    prefill: {
      name: '',
      email: '',
      phone: ''
    },
    theme: {
      color: '#0096C5',
    },
    modal: {
      escape: false,
      ondismiss:  () => {
        console.log('dismissed')
        this.orderApi.orderDelete(this.orderId).subscribe({
          next:(res:any) =>{
            console.log('97',res);
            this.orderId = null;
          }
        });
      }
    },
  };

  public proceed() {
    this.RAZORPAY_OPTIONS.amount = Number(this.cartService.totalPriceQuantity().total)*100;

    // binding this object to both success and dismiss handler
    this.RAZORPAY_OPTIONS['handler'] = this.razorPaySuccessHandler.bind(this);
    let razorpay = new Razorpay(this.RAZORPAY_OPTIONS);
    razorpay.open();
  }

  public razorPaySuccessHandler(response:any,error:any) {
    if(response){
      console.log(response);
      this.orderApi.orderUpdate(this.orderId,response).subscribe({
        next:(res:any) =>{
          console.log('97',res);
          this.orderId = null;
          this.checkoutForm.reset();
        }
      });
    }
    console.log('error',error);

    this.changeDetectorRef.detectChanges();
  }

  handleOpenLogin() {
    this.isOpenLogin = !this.isOpenLogin;
  }
  handleOpenCoupon() {
    this.isOpenCoupon = !this.isOpenCoupon;
  }



  handleCouponSubmit() {
    console.log(this.couponCode);
    // Add coupon code handling logic here
    if (this.couponCode) {
      // logic here
      // when submitted the from than empty will be coupon code
      this.couponCode = ''
    }
  }

  // handle payment item
  handlePayment(value: string) {
    this.payment_name = value
  }

  orderId:any = null;
  onSubmit(data:any) {
    if (this.checkoutForm.invalid) {
      this.formSubmitted = true;
    }else{
      this.formSubmitted = false;
      data.cart = this.cartService.getCartProducts();
      this.orderApi.orderPlaced(data).subscribe({
        next:(res:any) =>{
          console.log(res);
          if(res.success){

            this.orderId = res.order.id;
            this.RAZORPAY_OPTIONS.reference_id = res.order.id;
            //this.RAZORPAY_OPTIONS.order_id = res.order.id;
            this.RAZORPAY_OPTIONS.prefill.name = data.first_name;
            this.RAZORPAY_OPTIONS.prefill.name = data.last_name;
            this.RAZORPAY_OPTIONS.prefill.phone = data.phone;
            this.proceed();
          }
          //console.log(this.cartService.getCartProducts());
        },
      });


      //this.cartService.clear_cart();
    }
  }
}
